import React from "react";

const products = [
  {
    img: "images/fleets/Dzire.jpg",
    title: "Swift Dzire",
    price: "$120",
    oldPrice: "$180",
  },
  {
    img: "images/fleets/ertiga.jpg",
    title: "Ertiga",
    price: "$150",
    oldPrice: "$220",
  },
  {
    img: "images/fleets/innova.jpg",
    title: "Innova",
    price: "$200",
    oldPrice: "$280",
  },
  {
    img: "images/fleets/kia.jpg",
    title: "Kia Carens",
    price: "$190",
    oldPrice: "$260",
  },
  {
    img: "images/fleets/innova-crysta.jpg",
    title: "Innova Crysta",
    price: "$250",
    oldPrice: "$320",
  },
  {
    img: "images/fleets/rumion.jpg",
    title: "Rumion",
    price: "$170",
    oldPrice: "$240",
  },
  {
    img: "images/fleets/mini-bus.jpg",
    title: "Mini Bus",
    price: "$300",
    oldPrice: "$400",
  },
  {
    img: "images/fleets/tempo-traveller.jpg",
    title: "Tempo Traveller",
    price: "$350",
    oldPrice: "$450",
  },
  {
    img: "images/fleets/urbania.jpg",
    title: "Urbania",
    price: "$400",
    oldPrice: "$520",
  },
];

const Ourfleets = () => {
  return (
   <>
    <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">Our Fleets</h1>
          </div>
        </div>
      </div>


    <section className="g">
      <div className="container">
        <div className="row g-4">

          {products.map((item, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-4 col-md-6 "
            >
              <div className="shop-box-items mt-0 borderrr ">

                <div className="thumb img-fluid">
                  <img className="img-fluid" src={item.img} alt={item.title} />

               
                </div>

                <div className="content ">
                  
                  {/* ⭐ Stars */}
                  <div className="star">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="fas fa-star"></i>
                    ))}
                  </div>

                  <h4>{item.title}</h4>

                  {/* <ul className="price-list">
                    <li>{item.price}</li>
                    <li>
                      <del>{item.oldPrice}</del>
                    </li>
                  </ul> */}

                </div>

              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
   </>
  );
};

export default Ourfleets;